<app-topnav></app-topnav>
<div class="h-30"></div>
<div class="container">
  <div class="content" role="main">
    <div class="cmha-dashboard">
        <div class="h-30"></div>
              <div class="facility-heading">{{'userProfileText'|translate:translations}}</div>
      <form>
      <div class="designatedFacilityForm">
        <div class="review-form-fileds-status">
          <span class="heading">{{'editProfileText'|translate:translations}}</span>
        </div>

       <app-edit-profile-form [updateUser]="updateUser"></app-edit-profile-form>
        <div class="h-30"></div>
        <div class="form-buttons">
            <button class="submit-form-button" (click)="onUpdate()">{{'submitButtonText'|translate:translations}}</button>
        </div>
    </div>
    </form>
</div>
</div>
</div>
